import React from "react";

export default function Loader() {
  return (
    <>
        <div className="LinearLoader">
          <div className="bar1"></div>
          <div className="bar2"></div>
          <div className="bar3"></div>
          <div className="bar4"></div>
          <div className="bar5"></div>
          <div className="bar6"></div>
        </div>
    </>  
  );
}